import axios from 'axios';

export const sbaAxios = async ({
    url,
    method = 'get',
    headers = {},
    params = {},
    data = {},
    // timeout = 0,
    responseType = 'json',
    validateStatus = status => status >= 200 && status < 300,
}) => {

    const userToken = localStorage.getItem('entryKey');

    //Set TimeOut code for local storage
    //const timeoutDuration = 30 * 60 * 1000; // 30 minutes in milliseconds
    //const entryKey = 'entryKey';

    //localStorage.setItem(entryKey, JSON.stringify(tokenData));

    //// Set a timeout to clear the token after a certain period
    //const timeoutId = setTimeout(() => {
    //    localStorage.removeItem(entryKey);
    //    console.log('Token cleared due to inactivity.');
    //}, timeoutDuration);

    //// Listen for beforeunload event to clear the timeout when the user closes the browser or tab
    //window.addEventListener('beforeunload', () => {
    //    clearTimeout(timeoutId);
    //});


    const config = {
        url,
        method,
        headers: {
            'Content-Type': 'application/json', 
            'Authorization' : `Bearer ${userToken}`,
            ...headers,
        },
        params,
        data,
        // timeout,
        responseType,
        validateStatus,
    };

    try {
        const response = await axios(config);
        return response.data;
    } catch (error) {
        console.log(error);
        if(error.response.status===401)
        {
            localStorage.clear();
            window.location.href='/';
        }
        else
         throw error;
    }
};